import IM, { IM_STORE } from '@/data/im'
import { LOGIN_STATUS } from '@/data/im/constant'
import { App_User } from '@/data/user_info'
export const getMixin = ({
    page_key
}) => {
    return {
        data () {
            return {
                is_login: IM_STORE.login === LOGIN_STATUS.DONE
            }
        },
        watch: {
            is_login (latest) {
                if (latest) {
                    wx.hideLoading()
                }
            }
        },
        created () {
            if (!this.is_login) {
                wx.showLoading({
                    title: '请稍等',
                    mask: true
                })
            }
        },
        mounted () {
            this.initImLogin()
        },
        beforeDestroy () {
            IM_STORE.remove_login_watcher(page_key)
        },
        methods: {
            initImLogin () {
                App_User.get().then((user) => {
                    if (user.tag_list && user.tag_list.indexOf('天府通游客') === -1) {
                        if (IM_STORE.login === LOGIN_STATUS.NONE) {
                            IM.initIM()
                            IM.login()
                        }
                    }
                })
            },
            addLoginListener () {
                IM_STORE.remove_login_watcher(page_key)
                IM_STORE.add_login_watcher(page_key, login => {
                    this.is_login = login === LOGIN_STATUS.DONE
                })
            }
        }
    }
}